import { onMounted, defineComponent, ref, provide, reactive, toRefs, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Header2 from '@/components/layout/header2.vue';
import Footer from '@/components/layout/footer.vue';
import Menu from '@/components/layout/menu.vue';
import SideMenu from '@/components/layout/SideMenu.vue';
import SideComponent from '@/components/common/SideComponent.vue';
import {
  normalizeNoticeList,
  resolveNoticeLink,
} from '@/utils/phoneVerify';

export default defineComponent({
	components: {
		Header2,
		Menu,
		Footer,
		SideMenu,
		SideComponent,
	},
	setup() {
		const { proxy } = getCurrentInstance();
		const store = useStore();
		const router = useRouter();
		const data = reactive({
			showHeader: true,
			loginStyle: 'min-width:141px;',
			mobileIconStyle: 'color:rgba(223, 58, 8, 1);',
			showListIcon: true,
			list: [],
			pagination: {
				total: 0,
				current: 1,
				pageSize: 10,
			},
			loading: false,
		});
		const showMenu = ref(proxy.$menus);
		provide('showMenu', showMenu);
		const outerStyleStr = ref("position:relative;left:10%;top:40%;transform:translate(-10%,-40%);width:auto;");
		provide('outerStyleStr', outerStyleStr);
		const styleStr = ref("height:45px;");
		provide('styleStr', styleStr);
		const showSearchText = ref(false);
		provide('showSearchText', showSearchText);

		const viewBox = ref(null);
		const scroll = (val) => {
			if (val == 'top') {
				viewBox.value.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
			}
		};

		const fetchList = (page) => {
			if (typeof page === 'number') {
				data.pagination.current = page;
			}
			data.loading = true;
			store.dispatch('user/NoticeList', {
				page: data.pagination.current,
				pageSize: data.pagination.pageSize,
			}).then((res) => {
				const normalized = normalizeNoticeList(res);
				data.list = normalized.list;
				data.pagination = {
					...data.pagination,
					...normalized.pagination,
					current: normalized.pagination.current || data.pagination.current,
					pageSize: normalized.pagination.pageSize || data.pagination.pageSize,
					total: normalized.pagination.total ?? data.list.length,
				};
			}).catch((err) => {
				ElMessage({
					message: err?.message || err?.msg || proxy.$t('notice.empty'),
					grouping: true,
					type: 'error',
				});
			}).finally(() => {
				data.loading = false;
			});
		};

		const openNotice = (item) => {
			const link = resolveNoticeLink(item);
			if (link) {
				if (/^https?:\/\//i.test(link)) {
					window.location.href = link;
				} else {
					router.push(link);
				}
				return;
			}
			router.push({ name: 'notice_detail', params: { id: item.id } });
		};

		onMounted(() => {
			fetchList(1);
		});

		return {
			...toRefs(data),
			viewBox,
			scroll,
			fetchList,
			openNotice,
		};
	},
});
